import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import 'highcharts/highcharts-more'; // Needed for polar charts

function SpiderChartComponent({ className, categories, series, tickInterval }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const myChart = {
      chart: {
        polar: true,
        type: 'area',
        backgroundColor: 'transparent',
      },
      title: { text: '' },
      pane: {
        size: '90%',
      },
      xAxis: {
        categories,
        tickmarkPlacement: 'on',
        lineWidth: 0,
        // gridLineInterpolation: 'polygon',
      },
      yAxis: {
        visible: true,
        tickInterval,
        gridLineInterpolation: 'polygon',
        lineWidth: 0,
        min: 0,
        labels: { enabled: false },
      },
      tooltip: {
        shared: false,
        headerFormat: '',
        pointFormat: '{point.y}',
      },
      legend: {
        enabled: true,
        symbolRadius: 0,
        itemMarginBottom: 10,
        itemStyle: {
          fontFamily: 'NexusSans,"Helvetica Neue",Helvetica,Arial,sans-serif',
          fontWeight: 400,
          fontSize: '12px',
          color: '#505050',
        },
      },
      accessibility: {
        enabled: false,
      },
      plotOptions: {
        series: {
          events: {
            legendItemClick() {
              if (!this.visible) {
                return;
              }
              const count = this.chart.series.reduce((count, serie) => count + serie.visible, 0);
              return count > 1;
            },
          },
          marker: {
            enabled: true,
          },
        },
      },
      credits: { enabled: false },
      series,
    };
    Highcharts.chart(containerRef.current, myChart);
  }, [categories, series, tickInterval]);

  return <div className={className} ref={containerRef} />;
}

SpiderChartComponent.propTypes = {
  categories: PropTypes.array.isRequired,
  series: PropTypes.array.isRequired,
  tickInterval: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export default SpiderChartComponent;
